import api from '../utils/api';

export const FETCH_ASSIGNED_CHILDREN_SUCCESS = 'FETCH_ASSIGNED_CHILDREN_SUCCESS';
export const FETCH_TEACHERS_SUCCESS = 'FETCH_TEACHERS_SUCCESS';

export const fetchAssignedChildren = () => async (dispatch) => {
  try {
    const res = await api.get('/children/assigned'); // Adjust the endpoint as per your backend
    dispatch({
      type: FETCH_ASSIGNED_CHILDREN_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error('Error fetching assigned children:', error);
    // Handle error as needed
  }
};

export const fetchTeachers = () => async (dispatch) => {
  try {
    const res = await api.get('/teachers');
    dispatch({
      type: FETCH_TEACHERS_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error('Error fetching teachers:', error);
    // Handle error appropriately
  }
};
